const cloudinary = require('cloudinary-core');

module.exports = () => {
  const cl = new cloudinary.Cloudinary({cloud_name: "creative-distillery", secure: true});

  const teamMemberImages = document.querySelectorAll('.team-member-image');


  teamMemberImages.forEach((image) => {
    const url = image.getAttribute('data-url');
    if (url) {
      image.src = cl.url(url,
      {
        width: 200,
        height: 200,
        gravity: 'face',
        crop: 'thumb',
        radius: 'max',
        format: "png",
        type: "fetch"
      });
    }
  });
}
